import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
// components
import LoadingDots from '../../../../components/loading/LoadingRed';
import ButtonRequest from '../../../../components/buttons/ButtonRequest';
import InputTextFetchData from '../../../../components/form-elements/InputTextFetchData';
import { ToastSuccess, ToastErrorApi, ToastErrorCath } from '../../../../components/alerts/toast';
// api
import { addOverweight, calculateOverweight, getAdminDetailShipping } from '../../../api/Api-admin';

const OverweightModal = ({ isModalOpen, setIsModalOpen, setUpdatePage }) => {
  const initialValues = {
    id: '',
    serviceName: '',
    userName: '',
    depth: '',
    width: '',
    height: '',
    weight: '',
    volumetricWeight: '',
    totalWeight: '',
    realWeight: '',
    weightDiff: '',
    overweight: {},
  };
  const [shipping, setShipping] = useState(initialValues);
  const [isCalculateOverweight, setIsCalculateOverweight] = useState(false);
  const [isGettingData, setIsGettingData] = useState(false);
  // const [isRequestError, setIsRequestError] = useState(false);
  // const [requestError, setRequestError] = useState('');
  const [isShippingOk, setIsShippingOk] = useState(false);
  const [overweightCharges, setOverweightCharges] = useState(null); // AQUI SE GUARDA LA RESPUESTA DEL CALCULO DE SOBREPESO
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [isAddChargerLoader, setIsAddChargerLoader] = useState(false);

  // - Data Validation
  const updateField = (data, validation, field) => {
    // Eliminar espacios y caracteres especiales
    const cleanedData = data.replace(/[^a-zA-Z0-9 ]/g, '').trim();
    if (validation.test(cleanedData)) {
      setShipping({
        ...shipping,
        [field]: cleanedData,
      });
    } else {
      setShipping({
        ...shipping,
        [field]: '', // Limpiar el valor si no pasa la validación
      });
    }
  };
  const closeModal = () => {
    // Reset to initial values
    setShipping(initialValues);
    setIsModalOpen(false);
  };
  const closeModalAndRenderData = () => {
    closeModal();
    setUpdatePage(true);
  };
  // - Form autofill
  const getShippingData = async (e) => {
    const inputValue = e.target.value;
    const cleanedInputValue = inputValue.replace(/[^a-zA-Z0-9 ]/g, '').trim();
    const key = e.nativeEvent.inputType;
    setIsGettingData(true);
    // console.log('valores antes de actualizar', pickup);
    // If the user is deleting
    if (key === 'deleteContentBackward' || key === 'deleteContentForward') {
      setIsGettingData(false);
      return;
    }
    try {
      if (inputValue.length > 5) {
        const response = await getAdminDetailShipping(cleanedInputValue);
        // console.log('getAdminDetailShipping response:', response);
        if (response.shipping_code !== undefined) {
          setIsShippingOk(true); // to show div data
          // Set states with data from firebase Start
          setShipping({
            ...shipping,
            id: cleanedInputValue,
            serviceName: response.shipping_code,
            userName: response.razon_social,
            depth: response.parcel.depth,
            width: response.parcel.width,
            height: response.parcel.height,
            weight: response.parcel.weight,
            volumetricWeight: response.parcel.volumetric_weight,
            totalWeight: response.parcel.total_weight,
            overweight: response.shipping_overweights[0],
          });
        } else if (response.error) {
          setIsShippingOk(false);
          const firstKey = Object.keys(response.error)[0];
          ToastErrorApi(response.error[firstKey]);
          // handleRequestError(response.data.error.admin[0]);
          setShipping({
            ...shipping,
            id: cleanedInputValue,
            serviceName: '',
            userName: '',
            depth: '',
            width: '',
            height: '',
            weight: '',
            volumetricWeight: '',
            totalWeight: '',
            overweight: '',
          });
        }
      }
    } catch {
      ToastErrorCath();
    } finally {
      setIsGettingData(false);
    }
  };
  const handleCalculateOverweight = async () => {
    try {
      setIsCalculateOverweight(true);
      const response = await calculateOverweight(shipping.id, shipping.weightDiff, shipping.realWeight);
      // console.log('calculate overweight res:', response);
      if (response.overweight_charge_info !== undefined) {
        setOverweightCharges(response.overweight_charge_info);
      } else if (response.error) {
        const firstKey = Object.keys(response.error)[0];
        ToastErrorApi(response.error[firstKey]);
        setOverweightCharges(null);
      }
    } catch {
      ToastErrorCath(); // PORQUE CAE AQUI?
    } finally {
      setIsCalculateOverweight(false); // Esto siempre se ejecuta al final
    }
  };
  const handleButtonAction = () => {
    setIsButtonDisabled(true); // disable button
    setIsAddChargerLoader(true); // active loader in the button
    // Rehabilitar el botón después de 3 segundos
    setTimeout(() => setIsButtonDisabled(false), 3000);
  };
  const handlerAddOverweight = async () => {
    try {
      handleButtonAction();
      if (shipping.weightDiff || shipping.realWeight) {
        // console.log(`agregar sobrpesos de ${overweight} kg, en la guai numeror: ${labelId}`);
        const response = await addOverweight(shipping.id, shipping.weightDiff, shipping.realWeight);
        // console.log('add overweight res:', response);
        if (response.overweight_charge !== undefined) {
          ToastSuccess('Se agrego sobrepeso correctamente');
          closeModalAndRenderData();
        } else if (response.error) {
          const firstKey = Object.keys(response.error)[0];
          ToastErrorApi(response.error[firstKey]);
        }
      } else {
        ToastErrorCath('Error: Diferencia de kilos o peso real es requerido');
      }
    } catch {
      ToastErrorCath();
    } finally {
      setIsAddChargerLoader(false); // active loader in the button
    }
  };

  useEffect(() => {
    if (shipping.id.length === 0) {
      setIsShippingOk(false);
      // Reset to initial values
      setShipping(initialValues);
    }
  }, [shipping.id]);
  return (
    <Modal show={isModalOpen} onHide={() => closeModal()}>
      <Modal.Header closeButton>
        <Modal.Title>Sobrepeso</Modal.Title>
      </Modal.Header>
      <Modal.Body className="">
        <div>
          <InputTextFetchData
            label="ID Envío"
            icon="shipping"
            maxLength=""
            placeholder=""
            value={shipping.id}
            isRequired="false"
            // isError={isRequestError}
            // error={requestError}
            setValues={getShippingData}
            isLoading={isGettingData}
            fieldName="id"
            validation={/^[A-Z0-9 ]+$/i}
            setField={updateField}
            // cleanError={cleanError}
          />
          <div className={`bg-infoS w-100 flex-column flex-sm-row my-3 ${isShippingOk ? 'd-flex' : 'd-none'}`}>
            <span className="w-60">
              <p className="text-small text-muted mb-2">ENVIO</p>
              <div className="d-flex align-items-center lh-1-25">Usuario</div>
              {/* {data.razon_social.toUpperCase()} */}
              <div className="text-primary">{shipping.userName}</div>
              <div className="d-flex align-items-center lh-1-25 ">Servicio</div>
              <div className="text-primary">{shipping.serviceName}</div>
              {isCalculateOverweight ? (
                <div className="mt-5 bg-infoS">
                  <LoadingDots />
                </div>
              ) : (
                <>
                  {overweightCharges && (
                    <>
                      <p className="text-small text-muted mt-2 mb-1">SOBREPESO</p>
                      <div className="text-primary">
                        <span className="text-medium text-alternate pe-2"> Kilos a Cobrar:</span>
                        {overweightCharges?.kg_to_collect}
                      </div>
                      <div className="text-primary">
                        <span className="text-medium text-alternate pe-2"> Costo Sobrepeso:</span>
                        {overweightCharges?.extra_kg_cost}
                      </div>
                      <div className="text-primary">
                        <span className="text-medium text-alternate pe-2"> Cargo con IVA:</span>
                        {overweightCharges?.overweight_charge_with_iva}
                      </div>
                      <div className="text-primary">
                        <span className="text-medium text-alternate pe-2"> Peso Real:</span>
                        {overweightCharges?.real_weight}
                      </div>
                      <div className="text-primary">
                        <span className="text-medium text-alternate pe-2"> Kilos Amparados:</span>
                        {overweightCharges?.kg_coverage_for_shipping}
                      </div>
                    </>
                  )}
                </>
              )}
            </span>
            <span className="w-40 ps-sm-4">
              <p className="text-small text-muted mb-2 pt-4 pt-sm-0">PAQUETE</p>
              <div className="d-flex align-items-center lh-1-25">Medidas</div>
              <div className="text-primary">{`${shipping.depth} x ${shipping.width} x ${shipping.height} `}</div>
              <div className="d-flex align-items-center lh-1-25 mt-sm-4">Peso declarado</div>
              <div className="text-primary">
                <span className="text-medium text-alternate pe-2"> Físico:</span>
                {`${shipping.weight} kg`}
              </div>
              <div className="text-primary">
                <span className="text-medium text-alternate pe-3"> Volumétrico:</span>
                {`${shipping.volumetricWeight} kg`}
              </div>
              <div className="text-primary">
                <span className="text-medium text-alternate pe-3"> Final:</span>
                {`${shipping.totalWeight} kg`}
              </div>
            </span>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="d-flex flex-wrap justify-content-end bg-warningd">
          <Form.Control
            type="text"
            style={{ fontFamily: 'Poppins', width: '93px' }}
            className="me-2 mb-2"
            placeholder="Peso Real"
            value={shipping.realWeight}
            onChange={(e) => updateField(e.target.value, /^[0-9]+$/i, 'realWeight')}
          />
          <Form.Control
            type="text"
            style={{ fontFamily: 'Poppins', width: '96px' }}
            className="mb-2"
            placeholder="Diferencia"
            value={shipping.weightDiff}
            onChange={(e) => updateField(e.target.value, /^[0-9]+$/i, 'weightDiff')}
          />
          <Button variant="primary" size="lg" style={{ height: '36px' }} className="w-auto ms-2 mb-2" onClick={handleCalculateOverweight}>
            Calcular
          </Button>
          <ButtonRequest
            title="Aplicar"
            titleLoading="Cargando"
            handlerFn={handlerAddOverweight}
            isButtonDisabled={isButtonDisabled}
            isLoading={isAddChargerLoader}
          />

          {/* <Button
            variant="primary"
            disabled={isButtonDisabled}
            style={{ height: '36px' }}
            className="w-auto ms-2 mb-2 d-flex justify-content-between align-items-center"
            onClick={handlerAddOverweight}
          >
            {isAddChargerLoader && (
              <Spinner
                as="span"
                animation="border"
                role="status"
                aria-hidden="true"
                style={{
                  width: '13px',
                  height: '13px',
                  borderWidth: '1px',
                  color: '#FFFF',
                }}
              />
            )}
            <span>Aplicar</span>
          </Button> */}
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default OverweightModal;
